import React, { useEffect, useState } from "react";
import statergicplanbanner from "../../../main/assets/images/Images/Strategic Planning-Images/strategic-planning-banner.png";
import bgbannerMobile from "../../../main/assets/images/Images/Strategic Planning-Images/bgbannerMobile.png";
import sp_graph2 from "../../../main/assets/images/Images/Strategic Planning-Images/sp_graph2.png";
import sp_graph4 from "../../../main/assets/images/Images/Strategic Planning-Images/sp_graph4.png";
import sp_graph_1 from "../../../main/assets/images/Images/Strategic Planning-Images/sp_graph_1.png";
import sp_graph_2 from "../../../main/assets/images/Images/Strategic Planning-Images/sp_graph_2.png";
import sp_graph_3 from "../../../main/assets/images/Images/Strategic Planning-Images/sp_graph_3.png";
import sp_graph_4 from "../../../main/assets/images/Images/Strategic Planning-Images/sp_graph_4.png";
import globalscenario from "../../../main/assets/images/Images/Strategic Planning-Images/global-scenario-optimization-graf.png";
import enhancedbussiness from "../../../main/assets/images/Icons/Strategic Planning-Icons/enhanced-business-growth.svg";
import enhancedbusiness1 from "../../../main/assets/images/Icons/Strategic Planning-Icons/enhanced-business1.svg";
import futureReady from "../../../main/assets/images/Icons/Strategic Planning-Icons/future-ready-operations.svg";
import futurereday1 from "../../../main/assets/images/Icons/Strategic Planning-Icons/future-reday11.svg";
import optimizedresource from "../../../main/assets/images/Icons/Strategic Planning-Icons/optimized-resource-management.svg";
import optimizedresorurce1 from "../../../main/assets/images/Icons/Strategic Planning-Icons/optimized-resorurce1.svg";
import { Col } from "react-bootstrap";
import GraphDataOnLeft from "../../../main/components/componentsHelper/platformspage/GraphDataOnLeft";
import GraphDataOnRight from "../../../main/components/componentsHelper/platformspage/GraphDataOnRight";
import PlatformLearnMore from "main/components/componentsHelper/platformspage/PlatformLearnMore";
import { SectionCard } from "main/components";
import HeadingParagrap from "main/components/componentsHelper/platformspage/HeadingParagrap";
import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";
import PlatformModulesBanner from "main/components/componentsHelper/platformspage/PlatformModulesBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import SectionCardMobile from "main/components/componentsHelper/whtyantrapage/SectionCardMobile";
type Props = {};

interface CARDDATA {
  path: string;
  whiteIcon: string;
  title: string;
  textmsg: string;
}

const carddata: CARDDATA[] = [
  {
    path: futureReady,
    whiteIcon: futurereday1,
    title: "Future-Ready Operations",
    textmsg:
      "Secure your business against unforeseen challenges by strategizing based on comprehensive insights.",
  },
  {
    path: enhancedbussiness,
    whiteIcon: enhancedbusiness1,
    title: "Enhanced Business Growth",
    textmsg:
      "By identifying and acting on strategic opportunities early, foster steady and sustained growth.",
  },
  {
    path: optimizedresource,
    whiteIcon: optimizedresorurce1,
    title: "Optimized Resource Management",
    textmsg:
      "Ensure your workforce and inventory are always at their most efficient allocations, even as business scales or changes.",
  },
];
const Statergicplanning = (props: Props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activetIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <div>
      <PlatformModulesBanner
        graphImage={sp_graph_1}
        MobilebgImage={bgbannerMobile}
        mobilepraphImage={sp_graph_1}
        descriptionClass="text-white-color fonts-400 font-20 mb-20 font-family-roboto"
        HeaderClassName="text-white-color fonts-300 font-40 mb-10 font-family-condensed plat-header"
        backgroundImage={statergicplanbanner}
        heading="Strategic Planning"
        description="Deep dive into futuristic demand and supply"
        buttonGroup={
          <>
            <div className="d-block d-md-none">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                  className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
            <div className="d-none d-md-block">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                  className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
          </>
        }
      />
      <div>
        <HeadingParagrap
          heading=" Strategic Planning"
          headingpara="Take informed strategic decisions using AI enabled insights; capture proactive updates on maintenance schedules, order changes, technician upskilling and technician relocations."
        />
      </div>
      {/* website */}
      <div className="py-60 bg-color-n d-none d-md-block justify-content-center align-items-center">
        <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pb-60 justify-content-center align-items-center garph-heading">
          Key Capabilities
        </div>
        <div className="d-flex flex-column flex-gap-30 container justify-content-center align-items-center">
          <GraphDataOnLeft
            headingClass="text-black-10"
            path={sp_graph2}
            heading="Strategic Planning Dashboard"
            paragraph="Keep a track of unallocated supply and internal excess. Plan for the future with demand reshaping."
          />
          <GraphDataOnRight
            headingClass="text-black-10"
            path={globalscenario}
            heading="Global Scenario Optimization"
            paragraph="Plan and strategize with a comprehensive 12-24 months outlook, ensuring businesses remain proactive and ahead of the curve."
          />

          <GraphDataOnLeft
            headingClass="text-black-10"
            path={sp_graph4}
            heading="Strategic Control Center"
            paragraph="Utilize data-driven insights for crucial decisions, including cross-skilling, permanent relocations, and hiring."
          />
        </div>
      </div>
      {/* mobile View */}
      <div className="pb-30 bg-color-n d-block  d-md-none justify-content-center align-items-center">
        <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pt-40 pb-10 justify-content-center align-items-center garph-heading">
          Key Capabilities
        </div>
        <div className="d-flex flex-column flex-gap-20 py-30 container justify-content-center align-items-center graphcontainer">
          <GraphDataOnLeft
            headingClass="text-black-10"
            path={sp_graph2}
            heading="Strategic Planning Dashboard"
            paragraph="Keep a track of unallocated supply and internal excess. Plan for the future with demand reshaping."
          />
          <GraphDataOnRight
            headingClass="text-black-10"
            path={sp_graph_3}
            heading="Global Scenario Optimization"
            paragraph="Plan and strategize with a comprehensive 12-24 months outlook, ensuring businesses remain proactive and ahead of the curve."
          />

          <GraphDataOnLeft
            headingClass="text-black-10"
            path={sp_graph_4}
            heading="Strategic Control Center"
            paragraph="Utilize data-driven insights for crucial decisions, including cross-skilling, permanent relocations, and hiring."
          />
        </div>
      </div>
      {/* mobile */}
      <div className="d-block  d-md-none">
        <div className="container-fluid">
          <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mt-4 d-flex justify-content-center align-items-center plat-header">
            Benefits
          </h2>
          <div className="row mx-1 mb-40 p-10">
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={0}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper customSwiper"
            >
              {carddata.map((val, index) => (
                <SwiperSlide className="p-10">
                  <div className="col-md-12 col-sm-12 col-lg-12 p-10">
                    <Col key={index}>
                      <SectionCardMobile
                        classname="cards"
                        title={val.title}
                        icon={val.path}
                        whiteIcon={val.whiteIcon}
                        desc={val.textmsg}
                      />
                    </Col>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      {/* website */}
      <div className="d-none d-md-block pt-60 pb-30">
        <div className="container">
          <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mb-20 d-flex justify-content-center align-items-center plat-header">
            Benefits
          </h2>
          <div className="row mx-1 p-10">
            {carddata.map((item, index) => (
              <div className="col-md-6 col-sm-6 col-lg-4 p-10">
                <div
                  className={`scard-container d-flex flex-column py-20 radius-10 justify-content-center align-items-center border border-1`}
                  key={index}
                >
                  <div className="image-container">
                    <img
                      className="sfront-image mx-5 my-3 mt-4"
                      src={item?.path}
                      alt="background will be here"
                    />
                    <img
                      className="sback-image mx-5 mb-2"
                      src={item?.whiteIcon}
                      alt="background will be here"
                    />
                  </div>
                  <div className="card-body">
                    <p
                      className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-26 line-30 pb-2`}
                      style={{ color: "#3D1187" }}
                    >
                      {item?.title}
                    </p>
                    <p
                      className="px-3 tcard-desc text-center text-white-color fonts-400 font-16 line-20 font-family-roboto"
                      style={{ color: "#3D1187" }}
                    >
                      {item?.textmsg}
                    </p>
                  </div>
                </div>
                <div className="d-block d-md-none text-center">
                  <button
                    key={index}
                    className={
                      index === activetIndex
                        ? "active p-1"
                        : "banner-slider p-1"
                    }
                    onClick={() => goToSlide(index)}
                  ></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <PlatformLearnMore />
    </div>
  );
};

export default Statergicplanning;
